import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateContactName as UpdateContactNameMutation,
    UpdateContactNameVariables as UpdateContactNameVariables,
    ContactUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_CONTACT_NAME from '../mutations/update-contact-name.graphql';

export const useUpdateContactName = (): {
    updateContactName: (arg1: ContactUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateContactName, {loading, error}] = useMutation<
        UpdateContactNameMutation,
        UpdateContactNameVariables
    >(UPDATE_CONTACT_NAME);

    return {
        updateContactName: (input: ContactUpdateInput) => updateContactName({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
